import { GROUP_HEIGHT, GROUP_PADDING, GROUP_WIDTH } from '../../const';

export const TYPE_OPERATOR_BACKED_SERVICE = 'operator-backed-service';

export const OPERATOR_GROUP_WIDTH = GROUP_WIDTH;
export const OPERATOR_GROUP_HEIGHT = GROUP_HEIGHT;
export const OPERATOR_GROUP_PADDING = GROUP_PADDING;
